import axios from "axios";

let baseURL = window.location.origin;

// If the app is running in development mode, set the baseURL to localhost:8888
if (import.meta.env.VITE_APP_ENV === "development") {
  baseURL = "http://localhost:8888";
}

const netlifyApi = axios.create({
  baseURL: `${baseURL}/.netlify/functions`,
});

export default netlifyApi;
